<template>
  <div>
    <div class="link-warp">
      <div
        :class="['link-item', { active: item.value === $route.path }]"
        v-for="item in navList"
        :key="item.value"
      >
        {{ item.label }}
      </div>
      <Button v-if="toBack" class="goback btn-height45" @click="to"
        >返回</Button
      >
    </div>
    <div class="main">
      <router-view></router-view>
    </div>
  </div>
</template>
<script>
export default {
  name: "accountcontainer",
  data() {
    return {
      navList: [
        {
          active: true,
          value: "/user/account",
          label: "个人资料",
        },
      ],
      toBack: false,
    };
  },
  watch: {
    $route: {
      deep: true,
      immediate: true,
      handler(val) {
        let label = "";
        this.toBack = val.meta.toBack ? val.meta.toBack : false;
        switch (val.name) {
          case "account":
            label = "个人资料";
            break;
          case "accountSecurity":
            label = "安全中心";
            break;
          case "accountCertified":
            label = "我的认证";
            break;
          case "accountMail":
            label = "站内信";
            break;
          case "accountJournal":
            label = "登录日志";
            break;
          case "accountMyPersonal":
            label = "个人认证";
            break;
          case "accountMyEnterprise":
            label = "企业认证";
            break;
          case "accountMyEmail":
            label = "邮箱认证";
            break;
        }
        this.$set(this.navList, 0, {
          active: true,
          value: val.path,
          label: label,
        });
      },
    },
  },
  methods: {
    // 跳转路由
    onClick(val) {
      this.$router.push(val);
    },
    to() {
      this.$router.go(-1);
    },
  },
};
</script>

<style lang="less" scoped>
.link-warp {
  position: relative;
  background-color: #fff;
  padding: 0 30px;
  .link-item {
    display: inline-block;
    height: 80px;
    line-height: 80px;
    margin: 0 30px;
    color: #333;
    font-size: 20px;
    font-weight: 400;
    position: relative;
    cursor: pointer;
    transition: all 0.3s;
    &::before {
      content: "";
      position: absolute;
      bottom: 0;
      width: 0;
      height: 3px;
      background-color: transparent;
      transition: all 0.3s;
    }
  }
  .link-item.active {
    color: #3992e9;
    font-weight: bold;
    &::before {
      width: 100%;
      background-color: #3992e9;
    }
  }
  .goback {
    position: absolute;
    top: 50%;
    right: 60px;
    transform: translateY(-50%);
  }
}
.main {
  margin: 50px 60px;
}

.btn-height45 {
  height: 45px;
  line-height: 45px;
  min-width: 80px;
}
</style>
